import { Outlet, createRootRoute } from '@tanstack/react-router'
import * as React from 'react'

import { Ex } from '@/components/exceptions/Ex.tsx'

export const Route = createRootRoute({
  component: RootComponent,

  errorComponent: (error) => {
    return <Ex error={error} />
  },
})

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  )
}
